import loadSegmentSnippet from 'analytics';

const segmentIntegrations = {
  all: {},
  mpOnly: {
    All: false,
    Mixpanel: true,
  },
};

export default {
  load(token, debug) {
    loadSegmentSnippet();
    window.analytics.load(token);
    window.analytics.debug(debug);
  },

  analyticsReady(callback) {
    window.analytics.ready(callback);
  },

  getAnalytics() {
    return window.analytics;
  },

  trackEvent(name, properties, options, callback) {
    const opts = { ...segmentIntegrations.mpOnly, ...options };

    window.analytics.track(name, properties, opts, callback);
  },

  identifyUser(userId, traits, options, callback) {
    window.analytics.identify(userId, traits, options, callback);
  },

  userAlias(userId, previousId, options, callback) {
    window.analytics.alias(userId, previousId, options, callback);
  },

  resetUser() {
    window.analytics.reset();
  },
};



// WEBPACK FOOTER //
// ./tracker.sgmnt.js